import { useState } from "react";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, Field, FormError, SubmitButton, AuthLink } from "@/components/auth/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setResult(r.data);
    } catch (err) { setError(errorMessage(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send you a secure reset link."
      footer={<AuthLink to="/login" testId="forgot-back-link">Back to sign in</AuthLink>}>
      {result ? (
        <div className="space-y-4 rounded-2xl bg-emerald-50 border border-emerald-100 p-6" data-testid="forgot-success">
          <p className="text-emerald-900 font-medium">{result.message}</p>
          <p className="text-sm text-emerald-800">Check your inbox (and spam folder). The link works for one hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field id="email" label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" placeholder="you@example.com" testId="forgot-email-input" />
          <FormError message={error} />
          <SubmitButton loading={loading} testId="forgot-submit-button">Email me a reset link</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
